import { PromoCampaignsPage } from '@/pages/promo-campaign/promo-campaigns'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/promo/')({
	component: PromoCampaignsPage,
})
